/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

module.exports = {
    Room: function Room(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Room', function (data) {
            obj.Room = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    User: function User(obj, cb) {
        _scope.MsgBus.Sub('SendObj.User', function (data) {
            obj.User = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Comment: function Comment(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Comment', function (data) {
            obj.Comment = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    LuckyDraw: function LuckyDraw(obj, cb) {
        _scope.MsgBus.Sub('SendObj.LuckyDraw', function (data) {
            obj.LuckyDraw = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    PPT: function PPT(obj, cb) {
        _scope.MsgBus.Sub('SendObj.PPT', function (data) {
            obj.PPT = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Vote: function Vote(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Vote', function (data) {
            obj.Vote = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Barrage: function Barrage(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Barrage', function (data) {
            obj.Barrage = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Signup: function Signup(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Signup', function (data) {
            obj.Signup = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Topic: function Topic(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Topic', function (data) {
            obj.Topic = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Redpack: function Redpack(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Redpack', function (data) {
            obj.Redpack = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },

    Reward: function Reward(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Reward', function (data) {
            obj.Reward = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },
    Signin: function Signin(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Signin', function (data) {
            obj.Signin = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },
    Appointment: function Appointment(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Appointment', function (data) {
            obj.Appointment = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },
    Notice: function Notice(obj, cb) {
        _scope.MsgBus.Sub('SendObj.Notice', function (data) {
            obj.Notice = data;
            if (typeof cb === 'function') {
                cb(data);
            }
        });
    },
    EventBus: function EventBus(obj) {
        var _namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (_namespace != '') {
            _namespace = _namespace + '.';
        }
        obj.On = function (_topic, _cb) {
            return _scope.MsgBus.Sub(_namespace + _topic, _cb);
        };

        obj.Off = function (_key) {
            _scope.MsgBus.UnSub(_key);
        };

        obj.Fire = function (_topic, _data) {
            _scope.MsgBus.Pub(_namespace + _topic, _data);
        };
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/Feature.js
 ** module id = 127
 ** module chunks = 1
 **/